import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Account, ClientData } from '../user-profile-details/client-data';
import Swal from 'sweetalert2';
import { RequestService } from 'src/app/services/request.service';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';

interface SuggestionRequest {
  RelationCode: string;
  Body: string;
  ActionType: number;
}

@Component({
  selector: 'app-request-suggestion-modal',
  templateUrl: './request-suggestion-modal.component.html',
  styleUrls: ['./request-suggestion-modal.component.scss']
})
export class RequestSuggestionModalComponent implements OnInit {
  isSubmitting = false;
  @Input() selectedAccount: Account;
  titleMessage: string;
  textConfirmMassage: string;
  submitStatus;
  newSuggestion: SuggestionRequest = {} as SuggestionRequest;
  today = new Date();
  userPortfolio: ClientData;
  companyName: string;
  userAccounts: Account[];
  selectedAccountControl = new FormControl(null, Validators.required);
  accountList: Account[];


  constructor(
    public translate: TranslateService,
    private requestService: RequestService,
    private apiService: ApiService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.accountList = JSON.parse(localStorage.getItem("accList"));
    this.selectedAccount= this.accountList[0];
    this.clientSelected(this.selectedAccount);
    this.fetchUserPortfolio(this.selectedAccount);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedAccount && changes.selectedAccount.currentValue) {
      this.clientSelected(changes.selectedAccount.currentValue);
      this.fetchUserPortfolio(changes.selectedAccount.currentValue);
    }
  }
  clientSelected(e: Account) {
       
    this.userAccounts =   JSON.parse(localStorage.getItem("accList")) as Account[];
    this.selectedAccountControl.setValue(null);


  }
  

  fetchUserPortfolio(selectedAcc?) {
    if (selectedAcc) this.selectedAccount = selectedAcc;

    if (this.selectedAccount != null && this.selectedAccount.relationCode) {
      this.requestService.fetchUserPortfolio(this.selectedAccount.relationCode)
        .subscribe((res) => {
          this.userPortfolio = res as ClientData;
          this.companyName = this.userPortfolio.Profile.CompanyNameAr;
        });
    }
  }

  submitSuggestion(form: NgForm) {
    if (form && form.valid) {
      this.newSuggestion.RelationCode = this.selectedAccount.relationCode;
      this.newSuggestion.Body = form.value.Body;
      this.newSuggestion.ActionType = 11;
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد الاقتراح";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الاقتراح
      الحساب: ${this.selectedAccount.clientNameAr}
      الاقتراح:
      `;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Suggestion Confirmation";
        this.textConfirmMassage = `Please check The Information Before Sending The Suggestion
     Account: ${this.selectedAccount.clientNameEn}
     Suggestion:
     `;
      }
      Swal.fire({
        title: this.titleMessage,
        html:
          "<pre>" +
          this.textConfirmMassage +
          "</pre><p>" +
          form.form.value.Body +
          "</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiService.submitAction(this.newSuggestion).subscribe(
            (res) => {
              this.isSubmitting = false;
              if (res) this.submitStatus = res;
              form.resetForm();
              Swal.fire({
                position: "center",
                icon: "success",
                title: this.translate.instant("succes-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);
            },
            (err) => {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);
            }
          );
        } else if (!result.isConfirmed) {
          this.isSubmitting = false;
        }
      });
    }
  }
}